// extracted by mini-css-extract-plugin
export default {"search-input":"FilterSearchInput_search-input__FhRUF"};